import React from 'react'
import { useAuth } from '@/common/hooks/useAuth.ts'
import { useEmployeePublicInfo } from '@/common/hooks/useEmployeePublicInfo.tsx'

type ManagerRoutesProps = { children: React.ReactNode }

export const ManagerRoutes: React.FC<ManagerRoutesProps> = ({ children }) => {
  const { isHc, userProfile } = useAuth()
  const { checkIsManager } = useEmployeePublicInfo()

  if (!isHc && (!userProfile || !checkIsManager(userProfile.employeeId))) {
    throw new Error('Access Denied')
  }

  return children
}
